import React, { Component } from 'react';
// import {StripeProvider, Elements} from 'react-stripe-elements';
// import Paymentform from './paymentForm';
import { Elements, CardElement } from "@stripe/react-stripe-js";
import PaymentFormApp from "./paymentForm";

let stripe_apiKey = ''
let BASE_URL = "";

if (
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1"
) {
  BASE_URL = "http://localhost:8001";
} else if (window.location.hostname === "dev.cocoonsealy.net") {
  BASE_URL = "https://dev.cocoonsealy.net";
} else if (window.location.hostname === "cocoonbysealy.io") {
  BASE_URL = "https://cocoonbysealy.io";
} else if (window.location.hostname === "staging.cocoonbysealy.ca") {
  BASE_URL = "https://staging.tempurcloud.ca";
} else if (window.location.hostname === "cocoonbysealy.ca") {
  BASE_URL = "https://cocoonbysealy.ca";
}

// if (window.location.hostname === 'cocoonbysealy.ca') {
//     stripe_apiKey = 'pk_live_BLqlUVtwKf3HJrpgarS3ViDR00MqML3EOD'
// }else{
//     stripe_apiKey = 'pk_test_G0W0zyFQv55BfbOIpNukOxda00WYcdQbK1'
// }

class Payment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submit_payment: false,
            userlang: 'en',
            paymentType: "stripe",
            stripePromise: "",
            stripeElementOptions: ""
        }

    }
    disable_payment_button = (state) => {
        this.setState({
            submit_payment: state,
            userlang: this.props.userlang
        })
    }

    defaultPaymentType = paymentType => {
      let securityToken;
      let myform = document.getElementById("payment-form").elements;
      if (window.location.hostname === "localhost") {
        securityToken = "";
      } else {
        securityToken = myform["csrfmiddlewaretoken"].value;
      }

      this.setState({
        paymentType
      });

    }

    componentDidMount = () => {
      this.defaultPaymentType(this.state.paymentType);
    };

    render(){
      const { paymentType } = this.state;
      switch (paymentType) {
        case "":
        return(
          <PaymentFormApp
            disable_payment_button={this.disable_payment_button}
            submit_payment={this.state.submit_payment}
            userlang={this.props.userlang}
            paymentType={this.state.paymentType}
            // handlePaymentType={this.handlePaymentType}
          />
        );
        case "stripe":
        return(
          <PaymentFormApp
            disable_payment_button={this.disable_payment_button}
            submit_payment={this.state.submit_payment}
            userlang={this.props.userlang}
            paymentType={this.state.paymentType}
            // handlePaymentType={this.handlePaymentType}
          />
        );
      }
    }

}

interface IAppProps {}
interface IAppState {}

export default Payment;
